import { isBrowser } from 'motion/react';
import { useEffect, useState } from 'react';

export const useIsClient = () => isBrowser;

export const useHydrationSafeIsClient = () => {
  const [isHydrationSafeClient, setIsHydrationSafeClient] = useState<
    boolean | undefined
  >(undefined);
  const isClient = useIsClient();

  useEffect(() => {
    setIsHydrationSafeClient(isClient);
  }, [isClient]);

  return isHydrationSafeClient;
};
